import { AUTH_PATHS } from '~/domains/auth/consts';
import { Routes } from '~/domains/common/constants/routes';

/**
 * Returns a safe redirect path for post-login KYC flows.
 * Filters out auth paths (sign-in, sign-up, etc.) to prevent redirect loops.
 * Falls back to the home route when no valid redirect is provided.
 */
function getSafeRedirectPath(redirectTo?: string): string {
  if (!redirectTo || !redirectTo.startsWith('/') || redirectTo.startsWith('//')) {
    return Routes.home();
  }

  const isAuthPath = AUTH_PATHS.some((path) => redirectTo.startsWith(path));

  return isAuthPath ? Routes.home() : redirectTo;
}

export { getSafeRedirectPath };
